import { BASE_API } from "../utils/constants";

export async function downloadBackupApi(token) {
  try {
    const url = `${BASE_API}/api/backup/`;
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    if (!response.ok) {
      throw new Error("No se pudo generar el respaldo.");
    }

    const disposition = response.headers.get("Content-Disposition") || "";
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : `icard_backup_${Date.now()}.sqlite3`;

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    throw error;
  }
}

// Restaurar (solo Súper Usuario). `source` es { name } (respaldo del servidor)
// o { file } (archivo subido). Sin `confirm` solo revisa y devuelve qué tiene.
export async function getServerBackupsApi(token) {
  const response = await fetch(`${BASE_API}/api/backup/restore/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("No se pudo leer la lista de respaldos.");
  return response.json();
}

export async function restoreBackupApi(source, confirm, token) {
  const formData = new FormData();
  if (source.file) formData.append("file", source.file);
  else formData.append("name", source.name);
  if (confirm) formData.append("confirm", confirm);
  const response = await fetch(`${BASE_API}/api/backup/restore/`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || "No se pudo leer el respaldo.");
  return data;
}

// Guarda un respaldo de ahora en el servidor (aparece en la lista para restaurar).
export async function saveServerBackupApi(token) {
  const response = await fetch(`${BASE_API}/api/backup/save/`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("No se pudo guardar el respaldo.");
  return response.json();
}
